import { request } from '@/utils/request'

/**
 * 支付方式
 */
export const PayeeTypeEnum = {
  WechatPay: 1,
  AliPay: 2,
  Bank: 3
}

export const PayeeTypeOptions = [
  { label: '微信提现', value: 1 },
  { label: '支付宝提现', value: 2 },
  { label: '银行卡提现', value: 3 },
]

/**
 * 提现状态
 */
export const CashOutStatusEnum = [
  { label: '申请中', value: 0 },
  { label: '提现成功', value: 1 },
  { label: '提现失败', value: 2 },
  { label: '提现拒绝', value: 3 },
]

export const statusOptions = [
  {
    value: null,
    label: "全部",
  },
  {
    value: 0,
    label: "未发放",
  },
  {
    value: 1,
    label: "申请中",
  },
  {
    value: 2,
    label: "已发放",
  },
]

/** 用户名登录 */
export function loginByUnameApi<T = any>(data: object) {
  return request.post<T>('/auth/login', data)
}

/** 验证码登录 */
export function loginByPhoneApi<T = any>(data: object) {
  return request.post<T>('/auth/phone-login', data)
}

/** 发送验证码 */
export function sendVerifyCodeApi<T = any>(data: object) {
  return request.post<T>('/verify/send-phone-code', data)
}

/** 验证手机号是否可以登录 */
export function verifyLoginPhone<T = any>(data: object) {
  return request.post('/auth/verify-phone', data)
}


/** 获取个人信息 */
export function getProfileInfoApi<T = any>() {
  return request.get<T>('/user/profile')
}

/** 更新个人信息 */
export function updateProfileInfoApi<T, K>(data: K) {
  return request.post<T>('/user/update-profile', data)
}

/** 获取地址 */
export function getAddressPageApi<T = any>(params: any) {
  return request.get<T>('/address/page', params);
}

/** 添加地址 */
export function addAddressApi<T, K>(data: K) {
  return request.post<T>('/address/add', data)
}

/** 修改地址 */
export function updateAddressApi<T, K>(data: K) {
  return request.post<T>('/address/edit', data)
}

/** 自动登录 */
export function autoLogin<T>(params: any) {
  return request.get<T>('/auth/auto-login', params)
}

/** 修改头像 */
export function updateAvatarApi<T, K>(data: K) {
  return request.post<T>('/user/update-avatar', data)
}

/** 用户资产 */
export function getAssetApi<T = any>() {
  return request.get<T>('/user/assets')
}

/** 用户资产明细 */
export function getAssetDetailApi<T = any>(params: any) {
  return request.get<T>('/user/assets-detail', params);
}

/** 用户银行卡 */
export function getBankApi<T = any>() {
  return request.get<T>('/user/banks');
}

/** 绑定银行卡 */
export function bindBankApi<T, K>(data: K) {
  return request.post<T>('/user/bank', data);
}

/** 提现申请 */
export function cashOutApi<T, K>(data: K) {
  return request.post<T>('/user/cash-out', data);
}

/** 提现记录 */
export function getCashOutRecordApi<T = any>(params: any) {
  return request.get<T>('/user/cash-out-record', params);
}

/** 用户积分明细 */
export function getIntegralDetailApi<T = any>(params: any) {
  return request.get<T>('/user/integral-detail', params);
}

/** 用户订单明细 */
export function getOrdersApi<T>(params: any) {
  return request.get<T>('/user/orders', params);
}

/** 用户商品收藏列表 */
export function getOrdersCollectApi<T>(params: any) {
  return request.get<T>('/user/collect-orders', params);
}

/** 用户奖品明细 */
export function getPrizeItemApi<T>(params: any) {
  return request.get<T>('/user/prize-item', params);
}

/** 绑定手机号 */
export function bindMobileApi<T>(params: any) {
  return request.post<T>('/user/bind-mobile', params)
}

/** 用户安全信息明细 */
export function getSecurityApi<T>() {
  return request.get<T>('/user/security-detail');
}

/** 验证旧手机 */
export function validateOldMobileApi<T = any>(data: object) {
  return request.post<T>('/user/validate-old-mobile', data);
}

/** 获取帖子列表 */
export function getBbsPage<T = any>(params: any) {
  return {
    status: 1,
    results: { Items: [] }
  };
}

/** 更新密码 */
export function updPassword<T = any>(data: object) {
  return request.post<T>('/user/edit-password', data);
}

/** 用户元宝明细 */
export function getGoldingotDetailApi<T = any>(params: any) {
  return request.get<T>('/user/currency-detail', params);
}

/** 元宝兑换积分 */
export function exhcangeGoldByIntegralApi<T = any>(data: object) {
  return request.post<T>('/user/currency-exchange-integral', data);
}